export default {"src":"/_next/static/media/contest-benefits-1.4d04f7fb.svg","height":214,"width":377,"blurWidth":0,"blurHeight":0};